import { Button, ButtonAdd, Modal } from '@seiue/ui'
import { sortBy } from '@seiue/util'
import React from 'react'
import styled from 'styled-components'

import { Outline } from 'packages/sdks-next/growp'

import { EditCourseTaskContext } from '../context'

import { EditChapterNameModal } from './EditChapterNameModal'
import { OutlineItem } from './OutlineItem'
import { openSortOutlines } from './SortOutlines'

/**
 * 课程章节设置
 *
 * @returns 组件
 */
export const SetCourse: React.FC = () => {
  const { outlines, curTaskId, createIt } = React.useContext(
    EditCourseTaskContext
  )

  return (
    <>
      <SetCourseHeader>
        <HeaderTips>
          {
            '双层目录由课程章节和课程任务构成，课程任务为最小可学单位，共有视频、PDF、习题三类课程任务；'
          }
        </HeaderTips>
        <Button
          type="default"
          disabled={!outlines.length}
          onClick={() => {
            // 这里outlines的数据结构一定是 Outline[]
            openSortOutlines({ outlines: outlines as unknown as Outline[] })
          }}
          style={{
            marginRight: 0,
          }}
        >
          {'课程章节排序'}
        </Button>
      </SetCourseHeader>
      <OutlineItems>
        {sortBy(outlines, 'weight')?.map((outline, index) => {
          return (
            <OutlineItem
              key={index}
              outline={outline}
            />
          )
        })}
      </OutlineItems>
      <AddOutlineBox>
        <ButtonAdd
          type="link"
          onClick={() => {
            const { hide } = Modal.open({
              title: '添加课程章节',
              children: (
                <EditChapterNameModal
                  outlines={outlines}
                  hide={() => hide()}
                  activityTaskId={curTaskId}
                  createIt={createIt}
                />
              ),
              width: 480,
              footer: null,
              bodyStyle: { padding: 0 },
            })
          }}
        >
          {'添加课程章节'}
        </ButtonAdd>
      </AddOutlineBox>
    </>
  )
}

const SetCourseHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  &&& {
    .ant-btn-default[disabled] {
      background-color: ${(props) => props.theme.background._3};
    }
  }
`

const HeaderTips = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme.text._3};
  line-height: 20px;
`

const AddOutlineBox = styled.div`
  display: flex;
  align-items: center;
  padding: 12px auto 12px 36px;
  background-color: ${(p) => p.theme.background._3};
  border-radius: 8px;
  padding: 12px 32px;
  &&& {
    .se-button__link {
      font-weight: 400;
    }
  }
`

const OutlineItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  &&& {
    .ant-collapse-content-box {
      padding: 0;
    }
  }
`
